<div class="flex justify-center mt-5">
    <img src="/assets/images/auth/sign-out-popup-icon.svg" alt="Signout Icon" class="w-auto h-14" />
</div>

<mat-dialog-content class="text-center space-y-2">
    <p class="text-[#0A0A0A] text-[1.125rem] font-semibold">Sign Out?</p>
    <p class="text-[#717182] text-[0.875rem]">You'll need to sign in again to access your account.</p>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-col space-y-2">
    <button type="button" class="w-full border-button py-3 rounded-2xl" (click)="onOkay()">
        {{ confirmButtonLabel }}
    </button>
    <button type="button" class="w-full white-border-button py-3 rounded-2xl" (click)="onCancel()">
        {{ cancelButtonLabel }}
    </button>
</mat-dialog-actions>
